import { EntityInterface } from './interfaces/entityInterface.model';

export class CommentEntity {
    entity: EntityInterface;
    comment: string;
}
